import Immutable from 'immutable';
import { DocId } from 'records/Doc';

export type LinkId = string;

export interface RawLink {
  linkid: LinkId;
  sourcepageid: string;
  documentid: DocId;
  pageIndex: number;
  originalmarkupboundingbox: number[];
  destinationviewport: number[];
  destinationpageid: string;
  destinationSheetNunber: string;
  destinationUrl: string;
}

export interface LinkData {
  linkid: string;
  pageid: string;
  documentid: DocId;
  pageIndex: number;
  boundingBox: Immutable.List<number>;
  destinationviewport: Immutable.List<number>;
  destinationpageid: string;
  destinationsheetnumber: string;
  // If the destinationUrl is populated the destinationSheetNunber will not be
  destinationurl: string;
}

const defaultValues: LinkData = {
  linkid: '',
  pageid: '',
  documentid: '',
  pageIndex: 0,
  boundingBox: Immutable.List<number>(),
  destinationviewport: Immutable.List<number>(),
  destinationpageid: '',
  destinationsheetnumber: '',
  destinationurl: '',
};

export const LinkFactory = Immutable.Record(defaultValues, 'Link');

// export type Link = Immutable.Record<LinkData> & Readonly<LinkData>;

export class Link extends LinkFactory {
  static deserialize(rawLink: RawLink): Link {
    return new Link({
      ...rawLink,
      pageid: rawLink.sourcepageid,
      boundingBox: Immutable.List(rawLink.originalmarkupboundingbox),
      destinationviewport: Immutable.List(rawLink.destinationviewport),
    });
  }
}

export type LinkList = Immutable.List<Link>;

export type LinkMap = Immutable.OrderedMap<LinkId, Link>;
